/**
 * Angular Core Imports.
 */
import { Component, Input, OnInit } from '@angular/core';

/**
 * Service imports.
 */
import { GetService } from 'src/app/dataservice/get.service';
import { LanguageService } from 'src/app/dataservice/language.service';

/**
 * This component is created for intermediate/share page for meeting details.
 * It is being used to be shown to the user while navigating to meeting detail from deep link.
 */
@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrls: ['./meeting.component.css']
})
export class MeetingComponent implements OnInit {

  /**
   * API response received flag.
   */
  public finished: boolean = false;

  /**
   * Data received flag.
   */
  public isDataReceived = false;

  /**
   * No data exists flag.
   */
  public noRecFound = false;

  /**
   * Data received from API for the meeting.
   */
  public shareData: any;

  /**
   * Input properties from web share component.
   */

  /**
   * Product Type -> 41 for meeting.
   */
  @Input() productType: number;

  /**
   * Product Type ID -> Dyanmic Meeting ID.
   */
  @Input() productTypeId: number;

  /**
   * Referral ID of the user.
   */
  @Input() referralId: number;

  /**
   * Instantiate below services.
   * @param mls - Multi language service.
   * @param getApiService - Get HTTP Service for several products.
   */
  constructor(
    public mls: LanguageService,
    public getApiService: GetService) {
  }

  /**
   * Initialize meeting component.
   */
  ngOnInit(): void {
    this.getMeetingShareContent();
  }

  /**
   * Get meeting share content from get API.
   */
  getMeetingShareContent(): void {

    /**
     * If user is logged in, redirect to meeting detail page.
     */
    if (this.getApiService.is_login === '1') {
      this.navigatetoMeetingDetail();
    }

    this.finished = false;
    this.getApiService.getShareProductData(this.productType, this.productTypeId, this.referralId).subscribe(data => {
      this.finished = true;

      if (data.status === 1) {
        this.isDataReceived = true;

        if (!data['data']['share_data']) {
          this.noRecFound = true;
        }

        this.shareData = data['data']['share_data'];

      } else if (data.status === 0) {
        this.isDataReceived = false;
      }
    })
  }

  /**
   * Navigate user to  the meeting detail page.
   */
  navigatetoMeetingDetail(): void {
    this.getApiService.navigateToSection(41, this.productTypeId);
  }

}
